import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="page state-message">
      <p>Page not found.</p>
      <Link to="/">Back to the marketplace</Link>
    </div>
  );
}
